export default "__VITE_ASSET__CoXfGMtJ__"